<div *ngIf="isLoading | async" class="main-div">
	<div  class="contain-progress-spinner">
		<p-progressSpinner></p-progressSpinner>	
	</div>
</div>
